export var COOKIE_KEYS;

(function (COOKIE_KEYS) {
  COOKIE_KEYS["LANG"] = "lang";
})(COOKIE_KEYS || (COOKIE_KEYS = {}));

export var LOCALSTORAGE_KEYS;

(function (LOCALSTORAGE_KEYS) {
  LOCALSTORAGE_KEYS["NAV_OPEN_KEYS"] = "navOpenKeys";
  LOCALSTORAGE_KEYS["SIDE_BAR_THEME"] = "sideBarTheme";
  LOCALSTORAGE_KEYS["SIDE_BAR_COLLAPSED"] = "sideBarCollapsed";
  LOCALSTORAGE_KEYS["SOCKET_URL"] = "socketUrl";
  LOCALSTORAGE_KEYS["SOCKET_TYPE"] = "socketType";
  LOCALSTORAGE_KEYS["SOCKET_IO_EVENTS"] = "_socketIOEvents";
  LOCALSTORAGE_KEYS["DATA_FORMAT"] = "dataFormat";
  LOCALSTORAGE_KEYS["NOT_SUPPORT_POLLING"] = "notSupportPolling";
})(LOCALSTORAGE_KEYS || (LOCALSTORAGE_KEYS = {}));

export var SESSIONSTORAGE_KEYS;

(function (SESSIONSTORAGE_KEYS) {
  SESSIONSTORAGE_KEYS["USERINFO"] = "userInfo";
})(SESSIONSTORAGE_KEYS || (SESSIONSTORAGE_KEYS = {}));

export var LOGIN_CATEGORY = ['user', 'admin'];
export var SUCCESS_MESSAGE = 'הפעולה בוצעה בהצלחה!';
export var FIRST_CREATE_COMPANY_MESSAGE = 'לא ניתן לעשות פעולה זו קודם צריך להקים רשות!';
export var ERROR_MESSAGE = 'אירעה שגיאה';
export var UNSAVED_MESSAGE = 'ישנם שינוים שלא נשמרו, לצאת מהדף?';